// Thin wrapper around the Notification permission + the local rest-alert preference.
// Inside the Android shell there's no Web Notification API, so we delegate to native push (FCM).
import { nativePushSupported, isNativePushEnabled, enableNativePush } from "./nativePush.js";

export function notificationsSupported() {
  if (nativePushSupported()) return true;
  return "Notification" in window && "serviceWorker" in navigator;
}

export function permissionState() {
  // Native has no synchronous permission read; treat a registered token as "granted".
  if (nativePushSupported()) return isNativePushEnabled() ? "granted" : "default";
  if (!notificationsSupported()) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

export async function requestPermission() {
  if (nativePushSupported()) {
    try { await enableNativePush(); return "granted"; }
    catch { return "denied"; }
  }
  if (!notificationsSupported()) return "unsupported";
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
}

// Default ON: a rest timer that doesn't tell you the rest is over is the one thing it's for.
// Nothing is shown without an OS-level grant anyway (Notification permission on the web, the
// shell's POST_NOTIFICATIONS on Android), so this can't surprise anyone — it only stops the
// alert from being silently off for people who never found the toggle.
export function restAlertsEnabled() {
  try { return localStorage.getItem("notify_rest") !== "0"; } catch { return true; }
}

export function setRestAlerts(on) {
  try { localStorage.setItem("notify_rest", on ? "1" : "0"); } catch {}
  syncNativeRestPreference();
}

/** Keep the background FCM alarm receiver aligned with this device's existing local setting. */
export function syncNativeRestPreference() {
  const p = typeof window !== "undefined" ? window.Capacitor?.Plugins?.SharedRest : null;
  if (p?.setEnabled) {
    try { void p.setEnabled({ enabled: restAlertsEnabled() }); } catch {}
  }
}
